import { useGetApiV1ExamRevisionBotexamidVisualize } from '@/shared/api/generated';

/**
 * Carrega a visualização de uma prova gerada por IA a partir de
 * `GET /api/v1/exam/revision/{botExamId}/visualize`, uma questão por página
 * (paginação server-side), reaproveitando os componentes de preview.
 *
 * @param botExamId - ID da prova bot a visualizar
 * @param page - Página de questão atual (1-based)
 * @returns Dados da prova, questão atual, paginação e estados de loading/erro
 *
 * @example
 * ```tsx
 * const { exam, question, totalPages } = useRevisionVisualize(id, page);
 * ```
 */
export function useRevisionVisualize(botExamId: number, page: number) {
  const query = useGetApiV1ExamRevisionBotexamidVisualize(
    botExamId,
    { pageNumber: page, pageSize: 1 },
    { query: { enabled: botExamId > 0 } },
  );

  const data = query.data ?? null;

  return {
    exam: data,
    question: data?.questions?.[0] ?? null,
    currentPage: data?.currentPage ?? page,
    totalPages: data?.totalPages ?? 0,
    totalCount: data?.totalCount ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => {
      void query.refetch();
    },
  } as const;
}
